/* eslint-disable max-len */
import React from 'react'
import { Button, Row, Col } from 'antd'
import {
  CloseOutlined,
} from '@ant-design/icons'
import __ from '../../languages/parser'

import {
  COLOR_URLS, STEP_WALL_BASES_URL, STEP_BOARD_URL, ACCESSORIES_URL, STEP_BOARDS_DIMENSIONS_URL,
} from '../../static/url'

import { useIsSmallDevice } from '../../hookreducer/hooks'

const SwatchContent = ({ color }) => (
  <Row style={{ width: '100%', marginBottom: '6px' }}>
    <Col span={6} style={{ textAlign: 'center' }}>
      <img src={COLOR_URLS[color]} alt={__(color)} style={{ height: '28px', marginRight: '10px', marginTop: '-2px' }} />
    </Col>
    <Col span={18} style={{ fontWeight: '500' }}>
      <span>{__(color)}</span>
    </Col>
  </Row>
)


const Tuto = ({ setShowTuto }) => {
  const isSmall = useIsSmallDevice()

  const styleTitle = {
    marginTop: '30px',
  }
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      style={{
        position: 'relative',
        margin: 'auto',
        width: isSmall ? '90%' : '60%',
        height: isSmall ? '90%' : '80%',
        top: isSmall ? '5%' : '10%',
        backgroundColor: 'rgba(255,255,255,0.95)',
        zIndex: 1000001,
        padding: isSmall ? '10px' : '30px',
      }}
      onClick={(evt) => evt.stopPropagation()}
      onKeyDown={(evt) => evt.stopPropagation()}
      className="gassien-maker-tuto"
    >
      <Row justify="space-between" style={{ height: '50px', borderBottom: '1px solid #385623', marginBottom: '10px' }}>
        <Col>
          <h2>{__('Configurator').toUpperCase()}</h2>
        </Col>
        <Col>
          <Button
            style={{ lineHeight: '26px' }}
            shape="round"
            icon={<CloseOutlined />}
            onClick={() => setShowTuto(false)}
          />
        </Col>
      </Row>

      <div
        style={{
          overflow: 'hidden',
          overflowY: 'scroll',
          fontWeight: '400',
          height: '75%',
          marginBottom: '10px',
        }}
      >
        <p>{__('With our configurator you can design your own arrangement.')}</p>

        <h3 style={styleTitle}>{__('Finishes')}</h3>
        <p>{__('Select colors and finishes you want (you can change anytime during the configuration process).')}</p>
        <Row>
          <Col offset={isSmall ? 1 : 1} span={isSmall ? 22 : 10}>
            <h4>
              {__('wall bases colors')}
            </h4>
            <SwatchContent color="black" />
            <SwatchContent color="white" />
            <SwatchContent color="brass" />
          </Col>
          <Col offset={isSmall ? 1 : 2} span={isSmall ? 22 : 10}>
            <h4>
              {__('boards finishes')}
            </h4>
            <SwatchContent color="black" />
            <SwatchContent color="white" />
            <SwatchContent color="birch" />
            <SwatchContent color="oak" />
          </Col>
        </Row>

        <h3 style={styleTitle}>{__('Wall bases')}</h3>

        <p>
          {__('Start by disposing the wall bases you need (5 sizes), click on the button to make them appear and drag them as you want.')}
        </p>
        <div style={{ textAlign: 'center' }}>
          <img src={STEP_WALL_BASES_URL} alt="groupe étagères Gassien" style={{ width: isSmall ? '90%' : '80%' }} />
        </div>

        {!isSmall ? (
          <>
            <h3 style={styleTitle}>{__('Tips')}</h3>
            <p>
              {__('Define your space and principal items (radiator, window, sofa…) with [Space dimensions].')}
            </p>
          </>
        )
          : null}

        <h3 style={styleTitle}>{__('Boards')}</h3>
        <p>
          {__('Select your boards among 8 sizes and 2 desks. Drag them on your wall bases to compose your shelve.')}
        </p>
        <div style={{ textAlign: 'center' }}>
          <img src={STEP_BOARD_URL} alt="groupe étagères Gassien" style={{ width: isSmall ? '90%' : '40%' }} />
          <img src={STEP_BOARDS_DIMENSIONS_URL} alt="groupe étagères Gassien" style={{ width: isSmall ? '90%' : '60%' }} />
        </div>

        <h3 style={styleTitle}>{__('Accessories')}</h3>
        <p>
          {__('You can add some accessories to your composition:')}
        </p>
        <div style={{ textAlign: 'center' }}>
          <img src={ACCESSORIES_URL[__('languageCode')]} alt="accessoires Gassien Paris" style={{ width: isSmall ? '100%' : '100%' }} />
        </div>

        <h3 style={styleTitle}>{__('Order')}</h3>

        <p>
          {__('Your arrangement\'s price adjusts as the configuration progresses.')}
        </p>
        <p>
          {__('<b>[Details]</b> presents the configuration items list you can add to your cart.')}
        </p>
        <p>
          {__('contact us Tuto message')}

        </p>
      </div>

      <Row style={{
        height: '70px',
        width: '100%',
      }}
      >
        <Button block type="primary" shape="round" onClick={(evt) => { evt.stopPropagation(); setShowTuto(false) }}>{__('Start your composition')}</Button>
        <Button type="link" href="mailto:contact@gassien.com?subject=Informations Gassien" block>{__('Contact us')}</Button>
      </Row>
    </div>
  )
}

const TutoContainer = ({ showTuto, setShowTuto }) => (
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: showTuto ? 'block' : 'none',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(200,200,200,0.5)',
      zIndex: 1000000,
    }}
    className="tuto"
    onClick={() => setShowTuto(false)}
    onKeyDown={() => setShowTuto(false)}
  >
    <Tuto setShowTuto={setShowTuto} />
  </div>
)
export default TutoContainer
